import product1 from "../../Assets/Images/bas-peperzak-J1trUf0Lj3Q-unsplash.jpg";
import product2 from "../../Assets/Images/bathroom-g892011aff_640.jpg";
import product3 from "../../Assets/Images/chelsea-fern-FOF-epMl0EM-unsplash.jpg";
import product4 from "../../Assets/Images/conscious-design-ubeslMfS1lk-unsplash.jpg";
import product5 from "../../Assets/Images/emiliano-vittoriosi-dsy_ILnH69A-unsplash.jpg";
import product6 from "../../Assets/Images/emiliano-vittoriosi-qTu9DppC3mM-unsplash.jpg";
import product7 from "../../Assets/Images/engin-akyurt-g-m8EDc4X6Q-unsplash.jpg";
import product8 from "../../Assets/Images/glass-g221e6f6c4_640.jpg";
import product9 from "../../Assets/Images/hands-gd000f4952_640.jpg";
import product10 from "../../Assets/Images/katherine-hanlon-dpXBsRxAVHM-unsplash.jpg";
import product11 from "../../Assets/Images/katherine-hanlon-WAm_HaI4W2E-unsplash.jpg";
import product12 from "../../Assets/Images/khoa-pham-9nC7j1gAS84-unsplash.jpg";
import product13 from "../../Assets/Images/massage-g0bf546e00_640.jpg";
import product14 from "../../Assets/Images/massage-g6350a400c_640.jpg";
import product15 from "../../Assets/Images/naipo-de-C1sKadgZTr4-unsplash.jpg";
import product16 from "../../Assets/Images/toralf-thomassen-5S40ixhBK-I-unsplash.jpg";
import product17 from "../../Assets/Images/towfiqu-barbhuiya-vuctv0AnlwY-unsplash.jpg";
import product18 from "../../Assets/Images/wellness-g257add03d_640.jpg";

export const servicesProducts = [
  {
    id: 1,
    title: "Swedish Massage",
    description:
      "A massage using long, soothing strokes to refresh tired muscles, increase circulation, release toxins and relax your body. The Swedish massage is one of the most common types of massages you can get. It is performed to energize the body and improve overall health. This type of massage involves actions like percussion, kneading, vibration, tapping and rolling. Massage oil or lotion is used to protect the skin from friction.",
    duration: "60 minutes",
    price: "50",
    doThis: "30",
    likeThis: "95",
    images: [product1, product2, product3, product4, product5],
    howItRun: [
      "Arrive to spa",
      "Check your reservation with cashier",
      "Choose you favorite oil smell",
      "Go with your massier to your room",
      "Start massge with relaxing music in background",
      "After massage take shower in massage room bath 'if you need that'",
    ],
    howThisProgramHelpsYou: [
      "kneading",
      "long, flowing strokes in the direction of the heart",
      "deep circular motions",
      "vibration and tapping",
      "passive joint movement techniques",
    ],
    comments: [
      {
        id: 1,
        name: "vlyn28",
        content:
          "My sister and I booked the urban retreat option, on a Saturday, including a 30 minthe treatment was a Swedish back massage. Definitely one of the better massages I've had. Great pressure, great wide table, they turn down the lights and put a roll under your feet for comfort. Best part was the hot towel at the end. That was bliss. So hats off to Sanda my therapist.",
        commentDate: "10/2/2021",
        rate: "4",
      },
      {
        id: 2,
        name: "KMRMILK",
        content:
          "Dropped in whilst walking around Covent Garden and was able to get a lovely Swedish massage! Thank you Olga!",
        commentDate: "7/7/2021",
        rate: "4.5",
      },
      {
        id: 3,
        name: "احمد",
        content: "كان شعورا رائعا هذه الجلسه مع الاسترخاء",
        commentDate: "1/5/2022",
        rate: "5",
      },
    ],
  },
  {
    id: 2,
    title: "Hot stone massage",
    description:
      "Hot stone massage is best for people who have muscle pain and tension or who simply want to relax. This type of therapeutic massage is similar to a Swedish massage, only the massage therapist uses heated stones in lieu of or in addition to their hands. It eases muscle tension, improves blood flow, and relieves pain by using heated stones.",
    duration: "90 minutes",
    price: "100",
    doThis: "10",
    likeThis: "99",
    images: [product6, product7, product8, product9, product10, product11],
    howItRun: [
      "Arrive to spa",
      "Check your reservation with cashier",
      "Choose you favorite oil smell",
      "Go with your massier to your room",
      "Start massge with relaxing music in background",
      "After massage take shower in massage room bath 'if you need that'",
    ],
    howThisProgramHelpsYou: [
      "ease muscle tension",
      "improve blood flow",
      "alleviate pain",
      "promote relaxation",
      "relieve stress",
    ],
    comments: [
      {
        id: 1,
        name: "vlyn28",
        content:
          "My sister and I booked the urban retreat option, on a Saturday, including a 30 minthe treatment was a Swedish back massage. Definitely one of the better massages I've had. Great pressure, great wide table, they turn down the lights and put a roll under your feet for comfort. Best part was the hot towel at the end. That was bliss. So hats off to Sanda my therapist.",
        commentDate: "10/2/2021",
        rate: "4",
      },
      {
        id: 2,
        name: "KMRMILK",
        content:
          "Dropped in whilst walking around Covent Garden and was able to get a lovely Swedish massage! Thank you Olga!",
        commentDate: "7/7/2021",
        rate: "4.5",
      },
      {
        id: 3,
        name: "احمد",
        content: "كان شعورا رائعا هذه الجلسه مع الاسترخاء",
        commentDate: "1/5/2022",
        rate: "5",
      },
    ],
  },
  {
    id: 3,
    title: "Aromatherapy massage",
    description:
      "Aromatherapy massages are best for people who want to have an emotional healing component to their massage. Aromatherapy massages combine soft, gentle pressure with the use of essential oils. Your massage therapist will usually decide which essential oils to use, but you can let them know if you have a preference. Essential oils are diluted before being applied to the skin.During the massage, you’ll be given a full-body massage while inhaling essential oils through a diffuser and absorbing them through your skin. Sometimes an aromatherapy massage will only focus on your back, shoulders, and head. You won’t wear any clothing other than underwear, which is optional.",
    duration: "60 minutes",
    price: "60",
    doThis: "500",
    likeThis: "85",
    images: [product12, product13, product14],
    howItRun: [
      "Arrive to spa",
      "Check your reservation with cashier",
      "Choose you favorite oil smell",
      "Go with your massier to your room",
      "Start massge with relaxing music in background",
      "After massage take shower in massage room bath 'if you need that'",
    ],
    howThisProgramHelpsYou: [
      "boost your mood",
      "reduce stress and anxiety",
      "reduce symptoms of depression",
      "relieve muscle tension",
      "relieve pain",
    ],
    comments: [
      {
        id: 1,
        name: "vlyn28",
        content:
          "My sister and I booked the urban retreat option, on a Saturday, including a 30 minthe treatment was a Swedish back massage. Definitely one of the better massages I've had. Great pressure, great wide table, they turn down the lights and put a roll under your feet for comfort. Best part was the hot towel at the end. That was bliss. So hats off to Sanda my therapist.",
        commentDate: "10/2/2021",
        rate: "4",
      },
      {
        id: 2,
        name: "KMRMILK",
        content:
          "Dropped in whilst walking around Covent Garden and was able to get a lovely Swedish massage! Thank you Olga!",
        commentDate: "7/7/2021",
        rate: "4.5",
      },
      {
        id: 3,
        name: "احمد",
        content: "كان شعورا رائعا هذه الجلسه مع الاسترخاء",
        commentDate: "1/5/2022",
        rate: "5",
      },
    ],
  },
  {
    id: 4,
    title: "Deep tissue massage",
    description:
      "Deep tissue massage uses more pressure than a Swedish massage. It’s a good option if you have chronic muscle problems, such as soreness, injury, or imbalance. It can help relieve tight muscles, chronic muscle pain, and anxiety. During a deep tissue massage, your massage therapist will use slow strokes and deep finger pressure to relieve tension from the deepest layers of your muscles and connective tissues. You can be naked during this massage or wear your underwear. The massage will last for 60–90 minutes.  While deep tissue may be more intense, you shouldn’t feel any pain or soreness.",
    duration: "60 minutes",
    price: "80",
    doThis: "372",
    likeThis: "91",
    images: [product15, product16],
    howItRun: [
      "Arrive to spa",
      "Check your reservation with cashier",
      "Choose you favorite oil smell",
      "Go with your massier to your room",
      "Start massge with relaxing music in background",
      "After massage take shower in massage room bath 'if you need that'",
    ],
    howThisProgramHelpsYou: [
      "boost your mood",
      "reduce stress and anxiety",
      "reduce symptoms of depression",
      "relieve muscle tension",
      "relieve pain",
    ],
    comments: [
      {
        id: 1,
        name: "vlyn28",
        content:
          "My sister and I booked the urban retreat option, on a Saturday, including a 30 minthe treatment was a Swedish back massage. Definitely one of the better massages I've had. Great pressure, great wide table, they turn down the lights and put a roll under your feet for comfort. Best part was the hot towel at the end. That was bliss. So hats off to Sanda my therapist.",
        commentDate: "10/2/2021",
        rate: "4",
      },
      {
        id: 2,
        name: "KMRMILK",
        content:
          "Dropped in whilst walking around Covent Garden and was able to get a lovely Swedish massage! Thank you Olga!",
        commentDate: "7/7/2021",
        rate: "4.5",
      },
      {
        id: 3,
        name: "احمد",
        content: "كان شعورا رائعا هذه الجلسه مع الاسترخاء",
        commentDate: "1/5/2022",
        rate: "5",
      },
    ],
  },
  {
    id: 5,
    title: "Trigger point massage",
    description:
      "Trigger point massages are best suited for people who have injuries, chronic pain, or a specific issue or condition. Sometimes areas of tightness in the muscle tissues, known as trigger points, can cause pain in other parts of the body. By focusing on relieving trigger points, this type of massage can reduce pain.Trigger point massage uses broad, flowing strokes that are gentle and relaxing combined with stronger, deeper pressure. The massage will include work on your entire body, though your therapist will focus on specific areas of your body that need to be released. You can wear lightweight clothing for the massage or be fully or partially undressed. This type of massage will usually last for 60–90 minutes.",
    duration: "80 minutes",
    price: "105",
    doThis: "44",
    likeThis: "96",
    images: [product4, product5, product6, product8],
    howItRun: [
      "Arrive to spa",
      "Check your reservation with cashier",
      "Choose you favorite oil smell",
      "Go with your massier to your room",
      "Start massge with relaxing music in background",
      "After massage take shower in massage room bath 'if you need that'",
    ],
    howThisProgramHelpsYou: [
      "boost your mood",
      "reduce stress and anxiety",
      "reduce symptoms of depression",
      "relieve muscle tension",
      "relieve pain",
    ],
    comments: [
      {
        id: 1,
        name: "vlyn28",
        content:
          "My sister and I booked the urban retreat option, on a Saturday, including a 30 minthe treatment was a Swedish back massage. Definitely one of the better massages I've had. Great pressure, great wide table, they turn down the lights and put a roll under your feet for comfort. Best part was the hot towel at the end. That was bliss. So hats off to Sanda my therapist.",
        commentDate: "10/2/2021",
        rate: "4",
      },
      {
        id: 2,
        name: "KMRMILK",
        content:
          "Dropped in whilst walking around Covent Garden and was able to get a lovely Swedish massage! Thank you Olga!",
        commentDate: "7/7/2021",
        rate: "4.5",
      },
      {
        id: 3,
        name: "احمد",
        content: "كان شعورا رائعا هذه الجلسه مع الاسترخاء",
        commentDate: "1/5/2022",
        rate: "5",
      },
    ],
  },
  {
    id: 6,
    title: "Reflexology",
    description:
      "Reflexology is best for people who are looking to relax or restore their natural energy levels. It’s also a good option if you aren’t comfortable being touched on your entire body. Reflexology uses gentle to firm pressure on different pressure points of the feet, hands, and ears. You can wear loose, comfortable clothing that allows access to your legs.",
    duration: "60 minutes",
    price: "40",
    doThis: "99",
    likeThis: "93",
    images: [product17, product18],
    howItRun: [
      "Arrive to spa",
      "Check your reservation with cashier",
      "Choose you favorite oil smell",
      "Go with your massier to your room",
      "Start massge with relaxing music in background",
      "After massage take shower in massage room bath 'if you need that'",
    ],
    howThisProgramHelpsYou: [
      "boost your mood",
      "reduce stress and anxiety",
      "reduce symptoms of depression",
      "relieve muscle tension",
      "relieve pain",
    ],
    comments: [
      {
        id: 1,
        name: "vlyn28",
        content:
          "My sister and I booked the urban retreat option, on a Saturday, including a 30 minthe treatment was a Swedish back massage. Definitely one of the better massages I've had. Great pressure, great wide table, they turn down the lights and put a roll under your feet for comfort. Best part was the hot towel at the end. That was bliss. So hats off to Sanda my therapist.",
        commentDate: "10/2/2021",
        rate: "4",
      },
      {
        id: 2,
        name: "KMRMILK",
        content:
          "Dropped in whilst walking around Covent Garden and was able to get a lovely Swedish massage! Thank you Olga!",
        commentDate: "7/7/2021",
        rate: "4.5",
      },
      {
        id: 3,
        name: "احمد",
        content: "كان شعورا رائعا هذه الجلسه مع الاسترخاء",
        commentDate: "1/5/2022",
        rate: "5",
      },
    ],
  },
  {
    id: 7,
    title: "Shiatsu massage",
    description:
      "Shiatsu massage is best for people who want to feel relaxed and relieve stress, pain, and tension. Shiatsu massage works the whole body, but your therapist may focus on areas of your body that need extra attention. During the massage, your therapist will use their hands, palms, and thumbs to massage certain points of your body. Pulsing or rhythmic pressure is used. You can be fully clothed during this massage.",
    price: "75",
    doThis: "106",
    likeThis: "97",
    duration: "60 minutes",
    images: [product8, product7, product9, product10],
    howItRun: [
      "Arrive to spa",
      "Check your reservation with cashier",
      "Choose you favorite oil smell",
      "Go with your massier to your room",
      "Start massge with relaxing music in background",
      "After massage take shower in massage room bath 'if you need that'",
    ],
    howThisProgramHelpsYou: [
      "promotes emotional and physical calm and relaxation",
      "helps to relieve stress, anxiety, and depression",
      "may relieve headache",
      "reduces muscle tension",
    ],
    comments: [
      {
        id: 1,
        name: "vlyn28",
        content:
          "My sister and I booked the urban retreat option, on a Saturday, including a 30 minthe treatment was a Swedish back massage. Definitely one of the better massages I've had. Great pressure, great wide table, they turn down the lights and put a roll under your feet for comfort. Best part was the hot towel at the end. That was bliss. So hats off to Sanda my therapist.",
        commentDate: "10/2/2021",
        rate: "4",
      },
      {
        id: 2,
        name: "KMRMILK",
        content:
          "Dropped in whilst walking around Covent Garden and was able to get a lovely Swedish massage! Thank you Olga!",
        commentDate: "7/7/2021",
        rate: "4.5",
      },
      {
        id: 3,
        name: "احمد",
        content: "كان شعورا رائعا هذه الجلسه مع الاسترخاء",
        commentDate: "1/5/2022",
        rate: "5",
      },
    ],
  },
  {
    id: 8,
    title: "Thai massage",
    description:
      "Thai massage is best for people who want a more active form of massage and want to reduce and relieve pain and stress. Thai massage works the entire body using a sequence of movements that are similar to yogic stretching. Your therapist will use their palms and fingers to apply firm pressure to your body. You’ll also be stretched and twisted into various positions. You can wear loose, comfortable clothing during the massage.",
    price: "80",
    doThis: "22",
    likeThis: "91",
    duration: "80 minutes",
    images: [product11, product13, product14, product17],
    howItRun: [
      "Arrive to spa",
      "Check your reservation with cashier",
      "Choose you favorite oil smell",
      "Go with your massier to your room",
      "Start massge with relaxing music in background",
      "After massage take shower in massage room bath 'if you need that'",
    ],
    howThisProgramHelpsYou: ["flexibility", "circulation", "energy levels"],
    comments: [
      {
        id: 1,
        name: "vlyn28",
        content:
          "My sister and I booked the urban retreat option, on a Saturday, including a 30 minthe treatment was a Swedish back massage. Definitely one of the better massages I've had. Great pressure, great wide table, they turn down the lights and put a roll under your feet for comfort. Best part was the hot towel at the end. That was bliss. So hats off to Sanda my therapist.",
        commentDate: "10/2/2021",
        rate: "4",
      },
      {
        id: 2,
        name: "KMRMILK",
        content:
          "Dropped in whilst walking around Covent Garden and was able to get a lovely Swedish massage! Thank you Olga!",
        commentDate: "7/7/2021",
        rate: "4.5",
      },
      {
        id: 3,
        name: "احمد",
        content: "كان شعورا رائعا هذه الجلسه مع الاسترخاء",
        commentDate: "1/5/2022",
        rate: "5",
      },
    ],
  },
  {
    id: 9,
    title: "Prenatal massage",
    description:
      "Prenatal massage can be a safe way for women to get a massage during pregnancy. It can help reduce pregnancy body aches, reduce stress, and ease muscle tension. You can get a massage at any time during your pregnancy. However, many facilities, especially in the United States, do not offer massages to women in their first trimester due to the risk of miscarriage during this time. Prenatal massage uses mild pressure similar to Swedish massage. The therapist will focus on areas such as your lower back, hips, and legs. You can be fully or partially undressed depending on your comfort level. During the massage, you’ll either lie on your side or on a specially designed table with a cutout for your belly. If you’ve had pain in your calves or other parts of your leg, see a doctor before you have a massage.",
    price: "45",
    doThis: "212",
    likeThis: "91",
    duration: "50 minutes",
    images: [product9, product8, product12],
    howItRun: [
      "Arrive to spa",
      "Check your reservation with cashier",
      "Choose you favorite oil smell",
      "Go with your massier to your room",
      "Start massge with relaxing music in background",
      "After massage take shower in massage room bath 'if you need that'",
    ],
    howThisProgramHelpsYou: ["flexibility", "circulation", "energy levels"],
    comments: [
      {
        id: 1,
        name: "vlyn28",
        content:
          "My sister and I booked the urban retreat option, on a Saturday, including a 30 minthe treatment was a Swedish back massage. Definitely one of the better massages I've had. Great pressure, great wide table, they turn down the lights and put a roll under your feet for comfort. Best part was the hot towel at the end. That was bliss. So hats off to Sanda my therapist.",
        commentDate: "10/2/2021",
        rate: "4",
      },
      {
        id: 2,
        name: "KMRMILK",
        content:
          "Dropped in whilst walking around Covent Garden and was able to get a lovely Swedish massage! Thank you Olga!",
        commentDate: "7/7/2021",
        rate: "4.5",
      },
      {
        id: 3,
        name: "احمد",
        content: "كان شعورا رائعا هذه الجلسه مع الاسترخاء",
        commentDate: "1/5/2022",
        rate: "5",
      },
    ],
  },
  {
    id: 10,
    title: "Couple’s massage",
    description:
      "A couple’s massage is a massage that you do with your partner, friend, or family member in the same room. It brings all the benefits of a regular massage and sometimes provides you with access to the spa’s hot tubs, saunas, and other facilities. Other treatments such as pedicures, facials, and body scrubs are sometimes offered as part of a package.You can usually choose which type of massage you’d like to receive, and you and your partner can each get a different type of massage depending on your preference and the offerings at the spa. Your partner and you will be on tables side-by-side, and you’ll each have your own massage therapist working on your body. You can talk during the massage if you wish.",
    price: "80",
    doThis: "22",
    likeThis: "99",
    duration: "60 minutes",
    images: [product15, product17, product1, product3, product7],
    howItRun: [
      "Arrive to spa",
      "Check your reservation with cashier",
      "Choose you favorite oil smell",
      "Go with your massier to your room",
      "Start massge with relaxing music in background",
      "After massage take shower in massage room bath 'if you need that'",
    ],
    howThisProgramHelpsYou: ["flexibility", "circulation", "energy levels"],
    comments: [
      {
        id: 1,
        name: "vlyn28",
        content:
          "My sister and I booked the urban retreat option, on a Saturday, including a 30 minthe treatment was a Swedish back massage. Definitely one of the better massages I've had. Great pressure, great wide table, they turn down the lights and put a roll under your feet for comfort. Best part was the hot towel at the end. That was bliss. So hats off to Sanda my therapist.",
        commentDate: "10/2/2021",
        rate: "4",
      },
      {
        id: 2,
        name: "KMRMILK",
        content:
          "Dropped in whilst walking around Covent Garden and was able to get a lovely Swedish massage! Thank you Olga!",
        commentDate: "7/7/2021",
        rate: "4.5",
      },
      {
        id: 3,
        name: "احمد",
        content: "كان شعورا رائعا هذه الجلسه مع الاسترخاء",
        commentDate: "1/5/2022",
        rate: "5",
      },
    ],
  },
  {
    id: 11,
    title: "Chair massage",
    description:
      "A chair massage is best for people who want a quick massage that focuses on your neck, shoulders, and back. A chair massage can also be a way to introduce you to massage if you’ve never had one before. Chair massage also helps to relieve stress and promote relaxation. This type of massage uses light to medium pressure. During the massage, you’ll remain fully clothed and sit in a specially designed chair. You’ll straddle the chair so that your chest pushes into the back of the chair, allowing the massage therapist to have access to your back.",
    price: "30",
    doThis: "12",
    likeThis: "100",
    duration: "15 minutes",
    images: [product9, product10, product14, product8],
    howItRun: [
      "Arrive to spa",
      "Check your reservation with cashier",
      "Choose you favorite oil smell",
      "Go with your massier to your room",
      "Start massge with relaxing music in background",
      "After massage take shower in massage room bath 'if you need that'",
    ],
    howThisProgramHelpsYou: ["flexibility", "circulation", "energy levels"],
    comments: [
      {
        id: 1,
        name: "vlyn28",
        content:
          "My sister and I booked the urban retreat option, on a Saturday, including a 30 minthe treatment was a Swedish back massage. Definitely one of the better massages I've had. Great pressure, great wide table, they turn down the lights and put a roll under your feet for comfort. Best part was the hot towel at the end. That was bliss. So hats off to Sanda my therapist.",
        commentDate: "10/2/2021",
        rate: "4",
      },
      {
        id: 2,
        name: "KMRMILK",
        content:
          "Dropped in whilst walking around Covent Garden and was able to get a lovely Swedish massage! Thank you Olga!",
        commentDate: "7/7/2021",
        rate: "4.5",
      },
      {
        id: 3,
        name: "احمد",
        content: "كان شعورا رائعا هذه الجلسه مع الاسترخاء",
        commentDate: "1/5/2022",
        rate: "5",
      },
    ],
  },
];
